import { ChangeEvent } from 'react';
import { forceVisible } from 'react-lazyload';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import PageActions from 'app/store/page/page.actions';
// Selectors
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
import { selectFilter } from 'app/store/page/page.selectors';
// Mui
import { Box } from '@mui/material';
// Components
import { Select } from 'app/components/Mui';
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';

const PagesInWorkspaceSelect = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const trialMode = useAppSelector(selectTrialMode);
  const filter = useAppSelector(selectFilter);

  const handleChange = (event:ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    dispatch(PageActions.setFilter('pagesInWorkspace', value));
    dispatch(PagesToolbarActions.clearSelectedPages());
    forceVisible();
  }

  const options = [
    { id: 'all', name: 'All' },
    { id: 'true', name: 'In workspace' },
    { id: 'false', name: 'Not in workspace' }
  ];

  if ( trialMode ) return null;
  return (
    <Box sx={{ minWidth: 160 }}>
      <Select
        label="Pages"
        value={filter.pagesInWorkspace}
        onChange={handleChange}
        options={options}
        margin="none"
        size="small"
      />
    </Box>
  );
}

export default PagesInWorkspaceSelect;
